import { calendarClasses } from './date-picker-calendar.styles';
import { getMonthName } from './date-picker-utilities';
import { CalendarMenuProps, CalendarMenuType, ChevronLeftIcon, ChevronRightIcon, DatePickerActionType } from '../..';

export const MonthMenu = (props: CalendarMenuProps) => {
  const { state, dispatch } = props;
  const months = [];
  for (let i = 0; i < 12; ++i) {
    months.push(
      <button
        key={i}
        className={calendarClasses.menuButtonClasses}
        onClick={() => dispatch({ type: DatePickerActionType.SET_MONTH, month: i })}
      >
        {getMonthName(i, 'short')}
      </button>
    );
  }
  return (
    <div className={calendarClasses.containerClasses}>
      <div className={calendarClasses.headerClasses}>
        <div className="flex">
          <div className={calendarClasses.monthTextClasses}>
            <button
              title="year menu"
              className={calendarClasses.headerButtonClasses}
              onClick={() => dispatch({ type: DatePickerActionType.SET_MENU, menu: CalendarMenuType.YEAR_MENU })}
            >
              {state.year}
            </button>
          </div>
          <button
            title="prev year"
            className={calendarClasses.monthButtonClasses}
            onClick={() => dispatch({ type: DatePickerActionType.PREV_YEAR })}
          >
            <ChevronLeftIcon className={calendarClasses.monthButtonIconClasses} />
          </button>
          <button
            title="next year"
            className={calendarClasses.monthButtonClasses}
            onClick={() => dispatch({ type: DatePickerActionType.NEXT_YEAR })}
          >
            <ChevronRightIcon className={calendarClasses.monthButtonIconClasses} />
          </button>
        </div>
      </div>
      <div className={calendarClasses.monthGridClasses}>{months}</div>
    </div>
  );
};
